import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  // {
  //   path: 'visualizer/:zipCode/:vehicleCode/:cpos/:optionalCodes',
  //   loadChildren: () =>
  //     import('./pages/visualizer/visualizer.module').then(
  //       (m) => m.VisualizerPageModule
  //     ),
  // },
  // {
  //   path: 'visualizer/:zipCode/:vehicleCode/:cpos',
  //   loadChildren: () =>
  //     import('./pages/visualizer/visualizer.module').then(
  //       (m) => m.VisualizerPageModule
  //     ),
  // },
  // {
  //   path: 'visualizer/:zipCode/:vehicleCode',
  //   loadChildren: () =>
  //     import('./pages/visualizer/visualizer.module').then(
  //       (m) => m.VisualizerPageModule
  //     ),
  // },
  // {
  //   path: 'visualizer/:zipCode',
  //   loadChildren: () =>
  //     import('./pages/visualizer/visualizer.module').then(
  //       (m) => m.VisualizerPageModule
  //     ),
  // },
  // {
  //   path: 'visualizer',
  //   loadChildren: () =>
  //     import('./pages/visualizer/visualizer.module').then(
  //       (m) => m.VisualizerPageModule
  //     ),
  // },
  {
    path: ':zipCode/:vehicleCode/:cpos/:optionalCodes',
    loadChildren: () =>
      import('./pages/visualizer/visualizer.module').then(
        (m) => m.VisualizerPageModule
      ),
  },
  {
    path: ':zipCode/:vehicleCode/:cpos',
    loadChildren: () =>
      import('./pages/visualizer/visualizer.module').then(
        (m) => m.VisualizerPageModule
      ),
  },
  {
    path: ':zipCode/:vehicleCode',
    loadChildren: () =>
      import('./pages/visualizer/visualizer.module').then(
        (m) => m.VisualizerPageModule
      ),
  },
  {
    path: ':zipCode',
    loadChildren: () =>
      import('./pages/visualizer/visualizer.module').then(
        (m) => m.VisualizerPageModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/visualizer/visualizer.module').then(
        (m) => m.VisualizerPageModule
      ),
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
